<app-parameters-header [activeSection]="currentSection"></app-parameters-header>
<div class="parameters-container container">
  <div class="row parameters-body">
    <div class="d-none d-lg-block col-lg-3">
      <app-parameters-scrollspy [activeSection]="currentSection"></app-parameters-scrollspy>
    </div>
    <div class="col-12 col-lg-9" appScrollSpyMenu [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
      <div id="parameters-company" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-company [settings]='settings' [company]='true'></app-parameters-company>
      </div>
      <div id="parameters-accessibility" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-accessibility [settings]='settings' [company]='true'></app-parameters-accessibility>
      </div>
      <div id="parameters-reports" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-reports [company]='true' [settings]="settings" [report]="settings?.report">
        </app-parameters-reports>
      </div>
      <div id="parameters-options" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-options></app-parameters-options>
      </div>
      <div id="parameters-style" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-style [company]='true' [settings]="settings"></app-parameters-style>
      </div>
      <div id="parameters-users" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-users></app-parameters-users>
      </div>
      <div id="parameters-vehicle" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-vehicle [vehicle]="settings?.vehicle" [company]='true'></app-parameters-vehicle>
      </div>
      <div id="parameters-checkList" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-check-list [vehicle]="settings?.vehicle" [company]='true'></app-parameters-check-list>
      </div>
      <div id="parameters-cost" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-cost [report]="settings?.report" [company]='true' [vehicle]="settings?.vehicle"
          [cost]="settings?.cost">
        </app-parameters-cost>
      </div>
      <div id="parameters-tires" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-tires></app-tires>
      </div>
      <div id="parameters-notifications" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <!-- //TODO :  edit : <app-parameters-notifications [settings]="settings?.notification" ></app-parameters-notifications> -->
      </div>
      <div id="parameters-language" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-language [company]='true' [language]="settings?.language"></app-parameters-language>
      </div>
      <div id="parameters-apiwebhook" class="section-wrapper">
        <p class="section-scroll-anchor"></p>
        <app-parameters-apiwebhook [apiWebHook]="settings?.api"></app-parameters-apiwebhook>
      </div>
      <div id="parameters-exportkpi" class="section-wrapper" *ngIf="isSuperAdmin">
        <p class="section-scroll-anchor"></p>
        <app-export-kpi></app-export-kpi>
      </div>
      <div id="parameters-session" class="section-wrapper">
        <p class="section-scroll-anchor"></p>

        <div class="container">
          <div class="row head">
            <div class="col-12">
              <span class="title" i18n="parameters|@@session">Session</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 report-form">
              <span class="column-title" i18n="parameters|@@profile">Profil</span>
              <div class="container">
                <div class="row generalrows">
                  <div class="col-5 center">
                    <span class="span-txt"><span i18n="parameters|@@connectsAs">Connecté en tant que :</span>
                      {{username}}</span>
                  </div>
                  <div class="col-2">
                    <button i18n="parameters" type="button" class="btn btn-lg danger" (click)="logout()"
                      i18n="parameters|@@logout">Se
                      déconnecter</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/parameters/parameters.component.html